import { SystemDescriptions } from "src/common/descriptions"
import { PageCard } from "src/common/styles/styles"
import { PayablePaymentsComponent } from "../PayablePaymentsComponent"

export const PayableContractPayments = () => {

    const descriptions = SystemDescriptions.PAGES.PAYABLE_CONTRACT.PAYABLE_CONTRACT_PAYMENTS

    return (
        <PageCard
            size="small"
            title={descriptions.TITLE}
        >
            <PayablePaymentsComponent />
        </PageCard>
    )
}
